import * as signalR from "@microsoft/signalr"
import BaseComponent from '../../../core/infraestructure/BaseComponent';
import NotificationAlertsViewModel from '../../../core/features/shared/viewmodels/NotificationAlertsViewModel';
import { EventBus } from '../../../core/shared/helpers/EventHelper';

export default {
    extends: BaseComponent,
    data() {
        return {
            viewModel: null,
            notificationAlerts: [],
            totalAlertsNotifications: 0,
            notificationSelected: null,
        };
    },
    created() {
        this.connectoToSignalRHub();
        this.viewModel = new NotificationAlertsViewModel(this);
        this.onActive();
    },
    mounted() {
        // Cuando la pagina de notificaciones marca algo como leido, el
        // contador de la campana se refresca sin recargar toda la pagina.
        EventBus.$on('notifications-updated', this.onNotificationsUpdated);
    },
    beforeDestroy() {
        EventBus.$off('notifications-updated', this.onNotificationsUpdated);
    },
    methods: {
        onActive() {
            this.viewModel.bindNotificationAlerts();
        },
        onNotificationsUpdated() {
            this.viewModel.bindNotificationAlerts();
        },
        onFindNotificationAlertsResponse(response){
            this.notificationAlerts = response.data;
            this.totalAlertsNotifications = response.totalAlertsNotifications;
        },
        onSelectNotification(notification) {
            this.notificationSelected = notification;
            this.viewModel.doMarkAsRead(notification);
        },
        onMarkAsReadResponse() {
            if(this.notificationSelected.url){
                this.$router.push(this.notificationSelected.url, () => this.$router.go(0))
            }
        },
        mapImage(sender) {
            return (sender && sender.profileImageUrl) ?  sender.profileImageUrl : '/images/left-imgs/img-1.jpg'
        },
        connectoToSignalRHub() {
            
            let baseURL = '/notifications-events'

            if(process.env.NODE_ENV == 'development') {
                baseURL = location.protocol + '//' + location.hostname + ':5000/notifications-events'
            }
            
            const connection = new signalR.HubConnectionBuilder()
              .withUrl(baseURL)
              .configureLogging(signalR.LogLevel.Information)
              .withAutomaticReconnect()
              .build();
            connection.start({ withCredentials: false })
              .then(() => { connection.on("RefreshNotifications", this.onRefreshNotifications); })
              .catch(this.onError);
          },
          onRefreshNotifications(){
            this.viewModel.bindNotificationAlerts();
          }
    }
};
